import React from 'react';
export const Footer = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-navy text-white pt-20 pb-8 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" preserveAspectRatio="none" className="w-full h-20">
          <path fill="#FFFFFF" fillOpacity="1" d="M0,224L40,213.3C80,203,160,181,240,181.3C320,181,400,203,480,218.7C560,235,640,245,720,229.3C800,213,880,171,960,165.3C1040,160,1120,192,1200,192C1280,192,1360,160,1400,144L1440,128L1440,0L1400,0C1360,0,1280,0,1200,0C1120,0,1040,0,960,0C880,0,800,0,720,0C640,0,560,0,480,0C400,0,320,0,240,0C160,0,80,0,40,0L0,0Z"></path>
        </svg>
      </div>
      <div className="absolute top-20 right-10 opacity-10">
        
      </div>
      <div className="container relative z-10">
        <div className="text-center mb-12 mt-12">
          <div className="flex items-center justify-center mb-6">
            <img
              src="/assets/logo.jpg"
              alt="Perla del Pacífico"
              className="h-20 w-auto rounded-lg shadow-lg mr-3"
              style={{ background: 'white', padding: 2 }}
            />
          </div>
          <p className="text-xl font-playfair italic max-w-xl mx-auto text-gold">
            Tu viaje por el río Guayas comienza aquí
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <h3 className="font-playfair text-xl font-semibold mb-4 border-b border-white/20 pb-2">
              Contacto
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center">
                <span className="text-turquoise mr-2">›</span>
                <span>Muelle del Yacht Club Naval</span>
              </li>
              <li className="flex items-center">
                <span className="text-turquoise mr-2">›</span>
                <span>Malecón 2000, Guayaquil</span>
              </li>
              <li className="flex items-center">
                <span className="text-turquoise mr-2">›</span>
                <span>+593 9 XXX XXXX</span>
              </li>
              <li className="flex items-center">
                <span className="text-turquoise mr-2">›</span>
                <span>info@perladelpacifico.ec</span>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-playfair text-xl font-semibold mb-4 border-b border-white/20 pb-2">
              Enlaces rápidos
            </h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('inicio')} className="hover:text-turquoise transition-all duration-300 flex items-center group">
                  <span className="text-turquoise mr-2 transition-transform duration-300 group-hover:translate-x-1">
                    ›
                  </span>
                  Inicio
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('nosotros')} className="hover:text-turquoise transition-all duration-300 flex items-center group">
                  <span className="text-turquoise mr-2 transition-transform duration-300 group-hover:translate-x-1">
                    ›
                  </span>
                  Nosotros
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('itinerario')} className="hover:text-turquoise transition-all duration-300 flex items-center group">
                  <span className="text-turquoise mr-2 transition-transform duration-300 group-hover:translate-x-1">
                    ›
                  </span>
                  Itinerario
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('galeria')} className="hover:text-turquoise transition-all duration-300 flex items-center group">
                  <span className="text-turquoise mr-2 transition-transform duration-300 group-hover:translate-x-1">
                    ›
                  </span>
                  Galería
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonios')} className="hover:text-turquoise transition-all duration-300 flex items-center group">
                  <span className="text-turquoise mr-2 transition-transform duration-300 group-hover:translate-x-1">
                    ›
                  </span>
                  Testimonios
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contacto')} className="hover:text-turquoise transition-all duration-300 flex items-center group">
                  <span className="text-turquoise mr-2 transition-transform duration-300 group-hover:translate-x-1">
                    ›
                  </span>
                  Contacto
                </button>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-playfair text-xl font-semibold mb-4 border-b border-white/20 pb-2">
              Síguenos
            </h3>
            <div className="flex flex-wrap gap-3 mt-4">
              <a href="#" className="footer-social-btn" aria-label="Instagram">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
              <a href="#" className="footer-social-btn" aria-label="Facebook">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385h-3.047v-3.47h3.047v-2.642c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953h-1.514c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385c5.736-.9 10.126-5.864 10.126-11.854z" />
                </svg>
              </a>
              <a href="#" className="footer-social-btn" aria-label="Twitter">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                </svg>
              </a>
              <a href="#" className="footer-social-btn" aria-label="YouTube">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
              </a>
              <a href="#" className="footer-social-btn" aria-label="WhatsApp">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
              </a>
            </div>
            
          </div>
        </div>
                <div className="border-t border-white/10 pt-8 text-center">
          <p className="mb-2 text-white/70">
            &copy; {new Date().getFullYear()} Perla del Pacífico. Todos los
            derechos reservados.
          </p>
          <div className="flex justify-center space-x-4 text-sm text-white/50 mb-6">
            <a href="#" className="hover:text-turquoise transition-colors">
              Política de Privacidad
            </a>
            <span>|</span>
            <a href="#" className="hover:text-turquoise transition-colors">
              Términos y Condiciones
            </a>
          </div>
          <div className="flex items-center justify-center gap-2 text-white/50 text-sm">
            <span>Desarrollado por</span>
            <a href="https://ipse.com.ec" target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition-opacity">
              <img
                src="/assets/ipse_logo.png"
                alt="IPSE SA"
                className="h-8 w-auto"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>;
};